export default __webpack_public_path__ + "static/media/three_stone.4caf79dc.webp";